import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  CaretDownFilled,
  CaretUpFilled,
  PlusOutlined,
  UploadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Form,
  InputNumber,
  Input,
  Row,
  Select,
  Space,
  Typography,
  Modal,
  Upload,
  Image,
  message,
} from "antd";
import axios from "axios";
import APIEndpoint from "../../../../services/endpoint";
import { APPCONFIG } from "../../../../Config";
import { Content } from "antd/es/layout/layout";
import _ from "lodash";
import { masterDataFuture } from "../../../customer/touchpoint/components/dataReport";
import useCountry from "../../../../lib/hooks/useCountry";
import useCurrentStatus from "../../../../lib/hooks/useCurrentStatus";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../routes";
import { PAGES, PERMISSION_DATA ,SUCCESS_CODE} from "../../../../lib/const";
import usePermission from "../../../../lib/hooks/usePermisson";
import { SearchFutureCustomerPersonaContext } from '../searchContext';
import useYearFilterBC from "../../../../lib/hooks/useYearsFilterBC";
import { ThaiRangePicker } from "../../../../components/common/thaiDatePicker";
import {
  getDropDownMaster,
  getFutureCustomer,
  searchFutureCustomerAutocomplete,
  searchListByCompany,
  searchListContacts,
  updateImageFutureCustomer,

} from "../../../../services/customerFutures";
import { jsPDF} from "jspdf";
import html2canvas from "html2canvas";


const dateFormat = "DD/MM/YYYY";
const { Text , Title } = Typography;
const { Option } = Select;

const Search = ({ roleUser }) => {
  const {setSearchValues,
     setSearch,
     futureCusId } = useContext(SearchFutureCustomerPersonaContext);
  const [searchForm] = Form.useForm();
  const navigate = useNavigate();
  
  const [form] = Form.useForm();
  const [yearList] = useYearFilterBC();
  const [dropDownCurerntStatus, setDropDownCurerntStatus] = useState([]);

  const [waterLower, setWaterLower] = useState("");
  const [waterUpper, setWaterUpper] = useState("");
  const [areaLower, setAreaLower] = useState("");
  const [areaUpper, setAreaUpper] = useState("");
  const [electLower, setElectLower] = useState("");
  const [electUpper, setElectUpper] = useState("");
  const [wastLower, setWastLower] = useState("");
  const [wastUpper, setWastUpper] = useState("");

  const [areaSizeByRaiMin, setAreaSizeByRaiMin] = useState("");
  const [areaSizeByRaiMax, setAreaSizeByRaiMax] = useState("");

  const [areaSizeByNganMin, setAreaSizeByNganMin] = useState("");
  const [areaSizeByNganMax, setAreaSizeByNganMax] = useState("");

  const [areaSizeByWaMin, setAreaSizeByWaMin] = useState("");
  const [areaSizeByWaMax, setAreaSizeByWaMax] = useState("");

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const [searchCollapse, setSearchCollapse] = useState(false);

  const handleCollape = () => {
    setSearchCollapse(!searchCollapse);
  };

  const [dropDownCompanyType, setDropDownCompanyType] = useState([
      {
          dataId: "",
          dataDetailEn: "select all",
          dataDetailTh: "เลือกทั้งหมด",
          dataTopic: "company_type",
      },
  ]);
  const [dropDownIndustryType, setDropDownIndustryType] = useState([
      {
          dataId: "",
          dataDetailEn: "select all",
          dataDetailTh: "เลือกทั้งหมด",
          dataTopic: "company_type",
      },
  ]);
  const [dropDownAreaType, setDropDownAreaType] = useState([
      {
          dataId: "",
          dataDetailEn: "select all",
          dataDetailTh: "เลือกทั้งหมด",
          dataTopic: "company_type",
      },
  ]);
  const [dropDownKnowChannel, setDropDownKnowChannel] = useState([
      {
          dataId: "",
          dataDetailEn: "select all",
          dataDetailTh: "เลือกทั้งหมด",
          dataTopic: "company_type",
      },
  ]);
  const [dropDownRegionGroup, setDropDownRegionGroup] = useState([
      {
          dataId: "",
          dataDetailEn: "select all",
          dataDetailTh: "เลือกทั้งหมด",
          dataTopic: "company_type",
      },
  ]);
  const [dropDownPurpost, setDropDownPurpost] = useState([
      {
          dataId: "",
          dataDetailEn: "select all",
          dataDetailTh: "เลือกทั้งหมด",
          dataTopic: "company_type",
      },
  ]);
  const [companyAutocomplete, setCompanyAutocomplete] = useState([]);
  const [contactAutocomplete, setContactAutocomplete] = useState([]);
  const [countries, optionCountries] = useCountry();
  const [current_status, options] = useCurrentStatus();
  const [futureCustomerId, setFutureCustomerId] = useState("");

  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);

  const handleChangeInputNumber = (e, type) => {
    if (type.includes("water")) {
        if (type === "waterLower") {
            setWaterLower(e);
        } else {
            setWaterUpper(e);
        }
    }
    if (type.includes("elect")) {
        if (type === "electLower") {
            setElectLower(e);
        } else {
            setElectUpper(e);
        }
    }
    if (type.includes("wast")) {
        if (type === "wastLower") {
            setWastLower(e);
        } else {
            setWastUpper(e);
        }
    }
    if (type.includes("areaMaster")) {
        if (type === "areaMasterLower") {
            setAreaLower(e);
        } else {
            setAreaUpper(e);
        }
    }
    if (type.includes("areaSizeByRai")) {
        if (type === "areaSizeByRaiMin") {
            setAreaSizeByRaiMin(e);
        } else {
            setAreaSizeByRaiMax(e);
        }
    }
    if (type.includes("areaSizeByNgan")) {
        if (type === "areaSizeByNganMin") {
            setAreaSizeByNganMin(e);
        } else {
            setAreaSizeByNganMax(e);
        }
    }
    if (type.includes("areaSizeByWa")) {
        if (type === "areaSizeByWaMin") {
            setAreaSizeByWaMin(e);
        } else {
            setAreaSizeByWaMax(e);
        }
    }
  };
  const onSearch = async (values) => {
    let checkListYear = "";
    if (values.yearOfBudgets) {
        values.yearOfBudgets.map((item) => {
            if (item === "") {
                checkListYear = null;
            }
        });
    }

    let checkCompanyType = "";
    if (values.companyType) {
        values.companyType.map((item) => {
            if (item === "") {
                checkCompanyType = null;
            }
        });
    }

    let checkNationalityList = "";
    if (values.nationalityList) {
        values.nationalityList.map((item) => {
            if (item === "") {
                checkNationalityList = null;
            }
        });
    }

    let checkIndustryType = "";
    if (values.industryType) {
        values.industryType.map((item) => {
            if (item === "") {
                checkIndustryType = null;
            }
        });
    }

    let checkAreaType = "";
    if (values.areaType) {
        values.areaType.map((item) => {
            if (item === "") {
                checkAreaType = null;
            }
        });
    }

    let checkChannels = "";
    if (values.channels) {
        values.channels.map((item) => {
            if (item === "") {
                checkChannels = null;
            }
        });
    }

    let valueIsInvestmentAdvice = null;
    let valueIsVisitAreaLandInfo = null;

    //check search
    if (values.isInvestmentAdvice) {
        values.isInvestmentAdvice.map((item) => {
            if (item === "") {
                valueIsInvestmentAdvice = true;
                valueIsVisitAreaLandInfo = true;
            }
        });

        if (
            (values.isInvestmentAdvice[0] === "6a63c1b8-dbce-4398-ad5f-21bc3d438454" &&
                values.isInvestmentAdvice[1] === "ca2e0eed-f665-4f3d-8ba2-6a1d293e334b") ||
            (values.isInvestmentAdvice[0] === "ca2e0eed-f665-4f3d-8ba2-6a1d293e334b" &&
                values.isInvestmentAdvice[1] === "6a63c1b8-dbce-4398-ad5f-21bc3d438454")
        ) {
            valueIsInvestmentAdvice = true;
            valueIsVisitAreaLandInfo = true;
        } else if (values.isInvestmentAdvice[0] === "6a63c1b8-dbce-4398-ad5f-21bc3d438454") {
            valueIsInvestmentAdvice = true;
            valueIsVisitAreaLandInfo = null;
        } else if (values.isInvestmentAdvice[0] === "ca2e0eed-f665-4f3d-8ba2-6a1d293e334b") {
            valueIsInvestmentAdvice = null;
            valueIsVisitAreaLandInfo = true;
        }
    }

    setSearch(true);
    setSearchValues({
        yearOfBudgets: checkListYear === null ? [] : values.yearOfBudgets ? values?.yearOfBudgets : [],
        companyType: checkCompanyType === null ? [] : values.companyType ? values?.companyType : [],
        nationalityList: checkNationalityList === null ? [] : values.nationalityList ? values?.nationalityList : [],
        industryType: checkIndustryType === null ? [] : values.industryType ? values?.industryType : [],
        countryList: values?.customerRegion || [],
        statusList: values?.currentStatus || [],
        companyName: values?.companyName || "",
        contactName: values?.contactName || "",
        contactDateFrom: dateFrom != "" ? dateFrom : "",
        contactDateTo: dateTo != "" ? dateTo : "",
        areaSizeByRaiMin: areaSizeByRaiMin != "" ? areaSizeByRaiMin : "",
        areaSizeByRaiMax: areaSizeByRaiMax != "" ? areaSizeByRaiMax : "",
        areaSizeByNganMin: areaSizeByNganMin != "" ? areaSizeByNganMin : "",
        areaSizeByNganMax: areaSizeByNganMax != "" ? areaSizeByNganMax : "",
        areaSizeByWaMin: areaSizeByWaMin != "" ? areaSizeByWaMin : "",
        areaSizeByWaMax: areaSizeByWaMax != "" ? areaSizeByWaMax : "",
        areaSizeByMetersMax: areaUpper != "" ? areaUpper : "",
        areaSizeByMetersMin: areaLower != "" ? areaLower : "",
        waterConsumptionMin: waterLower != "" ? waterLower : "",
        waterConsumptionMax: waterUpper != "" ? waterUpper : "",
        wasteWaterMin: wastLower != "" ? wastLower : "",
        wasteWaterMax: wastUpper != "" ? wastUpper : "",
        kwMin: electLower != "" ? electLower : "",
        kwMax: electUpper != "" ? electUpper : "",
        areaType: checkAreaType === null ? [] : values.areaType ? values?.areaType : [],
        isInvestmentAdvice: valueIsInvestmentAdvice === null ? null : valueIsInvestmentAdvice === true ? true : null,
        isVisitAreaLandInfo: valueIsVisitAreaLandInfo === null ? null : valueIsVisitAreaLandInfo === true ? true : null,
        channels: checkChannels === null ? [] : values.channels ? values?.channels : [],
        futureCustomerId: values?.futureCustomerId || ""
    });
  };  
  const getListCompany = async (searchText) => {
    const res = await searchListByCompany(searchText);
    const { objectValue } = res.data;

    if (res?.data?.code === "0000") {
      const mapValue = objectValue.map((data, index) => {
        return {
          ...data,
          value: _.get(data, "companyNameTh") || _.get(data, "companyNameEn"),
          id: index,
          key: index,
        };
      });

      setCompanyAutocomplete(mapValue);
    } else {
      setCompanyAutocomplete([]);
    }
  };
  const onChangeRangePicker = (value, e) => {
    if (!value) {
      setDateFrom("");
      setDateTo("");
      return;
    }
    setDateFrom(value[0].format(dateFormat));
    setDateTo(value[1].format(dateFormat));
  };
  const getMaster = useCallback(
    async (toppicKey) => {
        try {
            const res = await getDropDownMaster(toppicKey);
            if (res.data.code === "0000") {
                let result_data = res.data.objectValue;

                if (toppicKey == "current_status") {
                    setDropDownCurerntStatus(result_data);
                } else if (toppicKey == "company_type") {
                    result_data.map((item) => {
                        dropDownCompanyType.push(item);
                    });
                } else if (toppicKey == "industry_type") {
                    //  setDropDownIndustryType(result_data);
                    result_data.map((item) => {
                        dropDownIndustryType.push(item);
                    });
                } else if (toppicKey == "area_type") {
                    result_data.map((item) => {
                        dropDownAreaType.push(item);
                    });
                    //  setDropDownAreaType(result_data);
                } else if (toppicKey == "known_channel") {
                    result_data.map((item) => {
                        dropDownKnowChannel.push(item);
                    });
                    //  setDropDownKnowChannel(result_data);
                } else if (toppicKey == "region_group") {
                    result_data.map((item) => {
                        dropDownRegionGroup.push(item);
                    });
                    //setDropDownRegionGroup(result_data);
                } else if (toppicKey == "purpose_contact") {
                    result_data.map((item) => {
                        dropDownPurpost.push(item);
                    });
                    //setDropDownPurpost(result_data);
                }
            }
        } catch (error) {
            // console.log("error==>", error);
        }
    },
    [dropDownCurerntStatus]
  );
  const getListContact = async (searchText) => {
    const res = await searchListContacts(searchText);
    const { objectValue } = res.data;

    if (res?.data?.code === "0000") {
      setContactAutocomplete(objectValue);
    } else {
      setContactAutocomplete([]);
    }
  };
  const onExportPDF = async (fileName) => {
    const input = document.getElementById("LIST_FUTURE_CUSTOMER");
    const canvas = await html2canvas(input, { useCORS: true });
  
    const imgData = canvas.toDataURL('image/png');
  
    const pdf = new jsPDF({ orientation: 'landscape' });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
  
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  
    pdf.save(fileName);
  };
  useEffect(() => {
    getListContact("");
  }, []);  
  useEffect(() => {
      masterDataFuture.map((item) => {
          getMaster(item);
      });
  }, []);
  //จุดเริ่ม อัพโหลดไฟล์
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [fileInfo, setFileInfo] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
    setImageUrl(null);
    setFileInfo(null);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setImageUrl(null);
    setFileInfo(null);
  };

  const handleOk = async () => {
    if (!fileInfo) {
      message.warning("กรุณาอัปโหลดไฟล์ก่อน");
      return;
    }
    let uploadedObj;
    try {
    uploadedObj = await onUploadFile({ file: fileInfo }, 0);
    } catch (err) {
    message.error("อัปโหลดไม่สำเร็จ: " + err.message);
    return;
    }
    const index = 0;
    const request = {
      futureCustomerId: futureCusId,
      fileName: uploadedObj.name,
      pathName: uploadedObj.path,
    };
    try {
      const res = await updateImageFutureCustomer(request);
      if (res.data.code === "0000") {
        setSuccessModal(true);
        setTimeout(() => {
          window.location.reload( {
            state: {},
          });
        }, 1000);
      } 
      else {
          setFailModal(true);
        }
      
      // setLoadingBtn(false);
    } catch (error) {
      setLoadingBtn(false);
    }
    setIsModalOpen(false);
  };
  const props = {
    beforeUpload: (file) => {
      const allowType =
        file.type === "image/jpeg" || file.type === "application/pdf";
      if (!allowType) {
        message.error(`${file.name} is not a  JPG, PDF file`);
      }
      return allowType || Upload.LIST_IGNORE;
    },
    onChange: (info) => {},
  };
  const onUploadFile = async (info, index) => {
    const newObj = {
      index: index,
      file: info.file.name,
      name: info.file.name,
      status: "uploading",
      uid: info.file.uid,
      url: "",
      path: "",
    };
    let formData = new FormData();
    formData.append("file", info.file);

    const api = APIEndpoint.UPLOAD_FILE_API;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("ACCESS_TOKEN")}`,
        "content-type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      APPCONFIG.GATEWAY_ENDPOINT + api,
      formData,
      config
    );
    if (res?.data?.code === SUCCESS_CODE) {
      message.success(`${res.data.message}`);
      const { objectValue } = res.data;
      newObj.status = "done";
      newObj.file = objectValue.fileName;
      newObj.name = objectValue.fileName;
      newObj.path = objectValue.filePath;
      if (fileList.length === 0) {
        setFileList([newObj]);
      } else {
        let newData = fileList.filter((item) => item.index !== index);
        newData.push(newObj);
        setFileList(newData);
      }
      form.setFields([
        {
          name: ["filePath", index],
          value: objectValue.filePath,
          errors: [],
        },
      ]);
    return newObj;
    } else {
      newObj.status = "error";
      message.error(`${res.data.message}`);
    }
  };
  //จุดจบ อัพโหลดไฟล์
  return (
    <Content>
      <Form style={{ marginBottom: 20 }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
          <div className="flex justify-between items-center">
                <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                  Future Customer Persona
                </Title>
                <div>
                  <Space>
                    {(roleUser[0]?.isAll || roleUser[0]?.isExport) && (
                      <>
                        <Button
                          onClick={() => onExportPDF("FutureCustomerPersona.pdf")}
                        >
                          <UploadOutlined /> Export PDF
                        </Button>
                        {/* <Button type="primary" onClick={showModal}>
                          เปิดอัปโหลดรูป
                        </Button> */}
                        {/* <Modal
                          title="อัปโหลด"
                          open={isModalOpen}
                          onCancel={handleCancel}
                          footer={[
                            <Button key="back" onClick={handleCancel}>
                              ยกเลิก
                            </Button>,
                            <Button key="submit" type="primary" onClick={handleOk}>
                              ยืนยัน
                            </Button>,
                          ]}
                        >
                          <Divider />
                          {imageUrl && (
                            <Row justify="center" style={{ marginBottom: 16 }}>
                              <Image width={200} src={imageUrl} alt="Preview" />
                            </Row>
                          )}
                          <Row justify="center">
                            <Upload
                              {...props}
                              showUploadList={false}
                              accept="image/jpg,image/jpeg,application/pdf"
                              customRequest={({ file, onSuccess }) => {
                                const reader = new FileReader();
                                reader.onload = () => {
                                  setImageUrl(reader.result);
                                  setFileInfo(file); // เก็บไฟล์ไว้ใช้ทีหลัง
                                  onSuccess("ok");
                                };
                                reader.readAsDataURL(file);
                              }}
                            >
                              <Button icon={<UploadOutlined />}>อัปโหลดรูป</Button>
                            </Upload>
                          </Row>
                          <Divider />
                        </Modal> */}
                      </>
                    )}
                  </Space>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <Form
        layout={"vertical"}
        form={searchForm}
        style={{
          padding: 20,
          backgroundColor: "#FCFCFC",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
        }}
        onFinish={(value) =>
          onSearch({
            ...value,
            futureCustomerId: futureCustomerId ? futureCustomerId : undefined,
          })
        }
        colon={false}
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"yearOfBudgets"}>
              <Select
                mode="multiple"
                placeholder="ปีงบประมาณ"
                // onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {yearList?.map((item, i) => {
                  return (
                    <Option key={i} value={item.value}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={16}></Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"companyType"}>
              <Select
                mode="multiple"
                placeholder="กลุ่มลูกค้าตามประเภทการจัดตั้งบริษัท"
                // onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {dropDownCompanyType.map((option, i) => {
                  return (
                    <Option key={i} value={option.dataId}>
                      {option.dataDetailTh}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"nationalityList"}>
              <Select
                mode="multiple"
                placeholder="กลุ่มลูกค้าตามสัญชาติ"
                // onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {dropDownRegionGroup.map((option, i) => {
                  return (
                    <Option key={i} value={option.dataId}>
                      {option.dataDetailTh}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"industryType"}>
              <Select
                mode="multiple"
                placeholder="กลุ่มลูกค้าตามกลุ่มอุตสาหกรรม"
                // onChange={handleChange}
                style={{
                  width: "100%",
                }}
              >
                {dropDownIndustryType.map((option, i) => {
                  return (
                    <Option key={i} value={option.dataId}>
                      {option.dataDetailTh}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name="companyName">
              <AutoComplete
                filterOption={true}
                options={companyAutocomplete}
                onSearch={(text) => getListCompany(text)}
              >
                <Input placeholder="ชื่อบริษัท" prefix={<SearchOutlined />} />
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name="contactName">
              <AutoComplete
                filterOption={true}
                options={contactAutocomplete}
                onSearch={(text) => getListContact(text)}
              >
                <Input
                  placeholder="ชื่อผู้ติดต่อ"
                  prefix={<SearchOutlined />}
                />
              </AutoComplete>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name="currentStatus">
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="สถานะปัจจุบัน"
                style={{
                  width: "100%",
                }}
                mode={"multiple"}
                maxTagCount={"responsive"}
                options={options}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name="customerRegion">
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="สัญชาติลูกค้า"
                style={{
                  width: "100%",
                }}
                mode={"multiple"}
                maxTagCount={"responsive"}
                options={optionCountries}
              />
            </Form.Item>
          </Col>


          {searchCollapse && (
            <>
              <Divider style={{ margin: 0 }} />

              <Col className="gutter-row" span={6}>
                <Form.Item
                  name={"contactDateFromTO"}
                  label="กลุ่มลูกค้าตามระยะเวลาการติดต่อ"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <ThaiRangePicker
                      placeholder={["DD/MM/YYYY", "DD/MM/YYYY"]}
                      onChange={onChangeRangePicker}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  label="กลุ่มลูกค้าตามปริมาณการใช้น้ำต่อเดือน ลูกบาศก์เมตร (ลบ.ม.)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="น้อยสุด"
                      width={50}
                      value={waterLower}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "waterLower");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="มากสุด"
                      width={50}
                      value={waterUpper}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "waterUpper");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  label="กลุ่มลูกค้าตามปริมาณการใช้ไฟฟ้า"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="น้อยสุด"
                      width={50}
                      value={electLower}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "electLower");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="มากสุด"
                      width={50}
                      value={electUpper}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "electUpper");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  label="กลุ่มลูกค้าตามปริมาณน้ำเสีย"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="น้อยสุด"
                      width={50}
                      value={wastLower}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "wastLower");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="มากสุด"
                      width={50}
                      value={wastUpper}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "wastUpper");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Divider style={{ margin: 0 }} />
              <Col className="gutter-row" span={14}>
                <Form.Item
                  label="ตามขนาดพื้นที่ที่ประกอบกิจการ (ไร่, งาน, วา)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="ไร่"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByRaiMin}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByRaiMin");
                      }}
                    />
                    <InputNumber
                      placeholder="งาน"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByNganMin}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByNganMin");
                      }}
                    />
                    <InputNumber
                      placeholder="วา"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByWaMin}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByWaMin");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="ไร่"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByRaiMax}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByRaiMax");
                      }}
                    />
                    <InputNumber
                      placeholder="งาน"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByNganMax}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByNganMax");
                      }}
                    />
                    <InputNumber
                      placeholder="วา"
                      style={{ width: 100 }}
                      min={0}
                      step="0.00"
                      value={areaSizeByWaMax}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaSizeByWaMax");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <span className="box-border-clound"></span>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label="ตามขนาดพื้นที่ที่ประกอบกิจการ (ตารางเมตร)"
                  style={{ fontWeight: 600, marginBottom: 0 }}
                >
                  <Space>
                    <InputNumber
                      placeholder="น้อยสุด"
                      width={50}
                      value={areaLower}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaMasterLower");
                      }}
                    />
                    <Text>-</Text>
                    <InputNumber
                      placeholder="มากสุด"
                      width={50}
                      value={areaUpper}
                      onChange={(event) => {
                        handleChangeInputNumber(event, "areaMasterUpper");
                      }}
                    />
                  </Space>
                </Form.Item>
              </Col>
              <Divider style={{ margin: 0 }} />

              <Col className="gutter-row" span={8}>
                <Form.Item name={"areaType"}>
                  <Select
                    mode="multiple"
                    placeholder="ตามประเภทพื้นที่ที่ต้องการ"
                    // onChange={handleChange}
                    style={{
                      width: "100%",
                    }}
                  >
                    {dropDownAreaType.map((option, i) => {
                      return (
                        <Option key={i} value={option.dataId}>
                          {option.dataDetailTh}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item name={"isInvestmentAdvice"}>
                  <Select
                    mode="multiple"
                    placeholder="วัตถุประสงค์ในการติดต่อ"
                    // onChange={handleChange}
                    style={{
                      width: "100%",
                    }}
                  >
                    {dropDownPurpost.map((option, i) => {
                      return (
                        <Option key={i} value={option.dataId}>
                          {option.dataDetailTh}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item name={"channels"}>
                  <Select
                    mode="multiple"
                    placeholder="ช่องทางการทราบข้อมูล กนอ."
                    // onChange={handleChange}
                    style={{
                      width: "100%",
                    }}
                  >
                    {dropDownKnowChannel.map((option, i) => {
                      return (
                        <Option key={i} value={option.dataId}>
                          {option.dataDetailTh}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </>
          )}

          <Col span={24} align="right">
            <Space>
              
              <Button onClick={handleCollape}>
                {!searchCollapse ? <CaretDownFilled style={{ fontSize: 17, color: "#2E90FA" }} /> : <CaretUpFilled style={{ fontSize: 17, color: "#2E90FA" }}/>}
              </Button>
              <Button
                onClick={() => {
                  searchForm.resetFields();
                  setDateTo("");
                  setDateFrom("");
                  setWaterLower("");
                  setWaterUpper("");
                  setAreaLower("");
                  setAreaUpper("");
                  setElectLower("");
                  setElectUpper("");
                  setWastLower("");
                  setWastUpper("");
                  setAreaSizeByRaiMin("");
                  setAreaSizeByRaiMax("");
                  setAreaSizeByNganMin("");
                  setAreaSizeByNganMax("");
                  setAreaSizeByWaMin("");
                  setAreaSizeByWaMax("");
                }}
              >
                ล้างข้อมูล
              </Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
